// extracted by mini-css-extract-plugin
module.exports = {"notesButton":"styles_notesButton__x-tFH","notesTitle":"styles_notesTitle__CG-d_","notesArea":"styles_notesArea__2PoKk","notesForm":"styles_notesForm__Mc369"};